import { FullClientPackage, calculateProjectTotal, QuotationRequest, FullProject } from 'entities';

export function calculateNewAvailableAmount(
  project: FullProject,
  selectedPackage?: FullClientPackage,
  quotationRequest?: QuotationRequest,
): number {
  const projectAmount = quotationRequest
    ? Number(quotationRequest.value)
    : calculateProjectTotal(project.services);

  const available = Number(selectedPackage?.amountAvailable ?? 0) - Number(projectAmount);

  return available;
}

export function canAttachProject(
  project: FullProject,
  selectedPackage?: FullClientPackage,
  quotationRequest?: QuotationRequest,
): boolean {
  const hasSpace = calculateNewAvailableAmount(project, selectedPackage, quotationRequest) >= 0;

  const canAttach = [!!selectedPackage, hasSpace].every(Boolean);

  return canAttach;
}
